import Card from '@components/Card';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useToggleFavoritePrepaidCard from '@hooks/prepaidCard/useToggleFavoritePrepaidCard';
import EditFill from '@icons/edit/EditFill';
import TrashFill from '@icons/TrashFill';
import { UserPrepaidCardRow } from '@models/prepaidCard';
import { Link } from '@stackflow/link';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useDeletePrepaidCard from './hooks/useDeletePrepaidCard';
import useUpdateName from './hooks/useUpdateName';
import LikeFillIcon from './LikeFillIcon';
import LikeIcon from './LikeIcon';

interface Props {
    prepaidCard: UserPrepaidCardRow;
}

function PrepaidCardItem({
    prepaidCard,
}:Props) {
    const { t } = useTranslation('prepaidCard');
    const {
        balance, imageUrl, id, createdAt, isFavorites,
    } = prepaidCard;
    const { handleDelete } = useDeletePrepaidCard({ id, balance });
    const { handleToggleFavorite } = useToggleFavoritePrepaidCard({ id, initialValue: prepaidCard.isFavorites });
    const Icon = isFavorites ? LikeFillIcon : LikeIcon;
    const { name, handleUpdateName } = useUpdateName({ id, initialValue: prepaidCard.name });
    return (
        <Row spacing={10} fullWidth align='flex-start'>
            <Icon size={30}
                color={colors.gray6}
                onClick={handleToggleFavorite} />
            <Link activityName='PrepaidCardLogActivity'
                activityParams={{ prepaidCardId: id }}
                css={css`width: 100%;`} >
                <Card>
                    <Card.Body>
                        <Row spacing={16} align='flex-start'
                            fullWidth >
                            <CardImage src={imageUrl}
                                width={90}
                                height={60}
                                alt={name} />
                            <NameWrapper>
                                <NameText size='lg'
                                    fontWeight='bold'>
                                    {name}
                                </NameText>
                            </NameWrapper>

                        </Row>
                        <Row fullWidth justify='flex-end'>
                            <Text size='xl' fontWeight='bold'>
                                {balance.toLocaleString()}{t('currencyUnit')}
                            </Text>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <Footer justify='space-between' fullWidth >
                            <Row>
                                <Text color={colors.gray6}>
                                    <b>{t('manage.registered')}</b>&nbsp;
                                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm:ss')}
                                </Text>
                            </Row>
                            <Row>
                                <EditFill size={24}
                                    color={colors.gray4}
                                    onClick={handleUpdateName} />
                                <TrashFill size={24}
                                    color={colors.gray4}
                                    onClick={handleDelete} />
                            </Row>
                        </Footer>
                    </Card.Footer>
                </Card>
            </Link>
        </Row>
    );
}

const CardImage = styled(Image)`
    border-radius: 4px;
    filter: drop-shadow(0 0.882px 7.057px rgba(0, 0, 0, 0.14));
`;

const NameWrapper = styled.div`
    flex: 1;
    overflow: hidden;
`;

const NameText = styled(Text)`
    -webkit-box-orient: vertical;
    max-width: 100%;
    -webkit-line-clamp: 2;
    width: 100%;
    overflow: hidden;
    max-height: 48px;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-word;
`;

const Footer = styled(Row)`
    padding: 0 12px;
`;

export default PrepaidCardItem;
